import {
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ClipboardDocumentListIcon,
	XMarkIcon,
} from "@heroicons/react/20/solid";
import { useState } from "react";
import { connect } from "react-redux";

const StatsModal = ({ stats, latestStats, currency }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [displayCard, setDisplayCard] = useState(true);

	return (
		<>
			<div
				className="btn btn-success pull-right"
				onClick={() => setIsOpen(true)}
			>
				<ClipboardDocumentListIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
				<div style={{ float: "left" }}>Dashboard</div>
			</div>
			<div
				className="modal"
				tabIndex="-1"
				role="dialog"
				aria-hidden={!isOpen}
				style={{
					visibility: isOpen ? "visible" : "hidden",
					display: "block",
					background: "rgba(0,0,0,0.4)",
					overflow: "scroll",
					transition: "opacity 0.5s ease-in-out, visibility 0.5s ease-in-out",
					opacity: isOpen ? 1 : 0,
					pointerEvents: isOpen ? "auto" : "none",
				}}
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="block block-themed block-transparent remove-margin-b p-0">
							<div
								className="block-header bg-primary-dark"
								style={{ padding: 20 }}
							>
								<ul className="block-options">
									<li>
										<button
											type="button"
											onClick={() => setIsOpen(false)}
										>
											<XMarkIcon className="h-6 w-6 mr-3 text-white" />
										</button>
									</li>
								</ul>
								<h3 className="block-title text-white">Advisor Dashboard</h3>
							</div>
							<div
								className="block-content"
								style={{ padding: 20 }}
							>
								<div className="col-xs-12 p-0 pl-3">
									<div
										className={`btn ${displayCard ? "btn-primary" : ""}`}
										style={{
											borderRadius: "1rem 0rem 0rem 1rem",
											width: "15%",
											backgroundColor: displayCard ? "" : "#f2f2f2",
											color: displayCard ? "" : "rgb(234,97,28)",
											boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
										}}
										onClick={() => setDisplayCard(true)}
									>
										Card
									</div>
									<div
										className={`btn ${displayCard ? "" : "btn-primary"}`}
										style={{
											borderRadius: "0rem 1rem 1rem 0rem",
											width: "15%",
											backgroundColor: displayCard ? "#f2f2f2" : "",
											color: displayCard ? "rgb(234,97,28)" : "",
											boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
										}}
										onClick={() => setDisplayCard(false)}
									>
										Chart
									</div>
								</div>
								{displayCard ? (
									<CardDisplay
										stats={latestStats}
										currency={currency}
									/>
								) : (
									<ChartDisplay
										stats={stats.sort((b, a) => a.period.localeCompare(b.period))}
										currency={currency}
									/>
								)}
								<div className="col-sm-12 p-0 pt-5">
									<div
										className="btn btn-danger pull-right"
										style={{ marginRight: 5 }}
										onClick={() => setIsOpen(false)}
									>
										Close
									</div>
								</div>
								<div className="clearfix" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const CardDisplay = ({ stats, currency }) => {
	return (
		<>
			<div className="col-xs-6 p-0 pl-3 mt-5">
				<div
					style={{
						padding: "1rem 1rem 1rem 1rem",
						borderRadius: "1rem 1rem 0rem 0rem",
						backgroundColor: "rgb(234,97,28)",
						fontSize: "1.5rem",
						color: "white",
						fontWeight: "bolder",
						boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
					}}
				>
					<h4>Employees</h4>
				</div>
				<div
					style={{
						borderRadius: "0rem 0rem 1rem 1rem",
						backgroundColor: "#FAFAFA",
						padding: "1rem 0",
						fontSize: "1.5rem",
						fontWeight: "600",
						boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
					}}
				>
					<div className="col-xs-12 pl-5 mb-1">
						{`Total Employees: ${stats?.people?.count}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="col-xs-12 pl-5 mb-1">
						{`Weekly Salary: ${currency}${parseFloat(stats?.people?.weeklySalary.toFixed(2))}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div
						className="col-xs-12 pl-5"
						style={{ paddingBottom: "5.4rem" }}
					>
						{`Annual Salary: ${currency}${parseFloat(stats?.people?.annualSalary.toFixed(2))}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="clearfix" />
				</div>
			</div>
			<div className="col-xs-6 p-0 pl-3 mt-5">
				<div
					style={{
						padding: "1rem 1rem 1rem 1rem",
						borderRadius: "1rem 1rem 0rem 0rem",
						backgroundColor: "rgb(234,97,28)",
						fontSize: "1.5rem",
						color: "white",
						fontWeight: "bolder",
						boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
					}}
				>
					<h4>Payrolls</h4>
				</div>
				<div
					style={{
						borderRadius: "0rem 0rem 1rem 1rem",
						backgroundColor: "#FAFAFA",
						padding: "1rem 0",
						fontSize: "1.5rem",
						fontWeight: "600",
						boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
					}}
				>
					<div className="col-xs-12 pl-5 mb-1">
						{`Total Payrolls: ${stats?.payroll?.count}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="col-xs-12 pl-5 mb-1">
						{`Gross: ${currency}${parseFloat(stats?.payroll?.gross?.toFixed(2))}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="col-xs-12 pl-5 mb-1">
						{`Net: ${currency}${parseFloat(stats?.payroll?.net?.toFixed(2))}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="col-xs-12 pl-5 mb-1">
						{`Tax: ${currency}${parseFloat(stats?.payroll?.tax?.toFixed(2))}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="col-xs-12 pl-5 mb-1">
						{`Total Cost: ${currency}${parseFloat(stats?.payroll?.totalCost?.toFixed(2))}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="clearfix" />
				</div>
			</div>
			<div className="col-xs-6 p-0 pl-3 mt-5">
				<div
					style={{
						padding: "1rem 1rem 1rem 1rem",
						borderRadius: "1rem 1rem 0rem 0rem",
						backgroundColor: "rgb(234,97,28)",
						fontSize: "1.5rem",
						color: "white",
						fontWeight: "bolder",
						boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
					}}
				>
					<h4>Businesses</h4>
				</div>
				<div
					style={{
						borderRadius: "0rem 0rem 1rem 1rem",
						backgroundColor: "#FAFAFA",
						padding: "1rem 0",
						fontSize: "1.5rem",
						fontWeight: "600",
						boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1)",
					}}
				>
					<div className="col-xs-12 pl-5 mb-1">
						{`Independent: ${stats?.businesses?.count - stats?.businesses?.paidByAdvisor}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="col-xs-12 pl-5 mb-1">
						{`Paid By Advisor: ${stats?.businesses?.paidByAdvisor}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="col-xs-12 pl-5 mb-1">
						{`Total Businesses: ${stats?.businesses?.count}`}
						<div
							className="col-xs-9"
							style={{ borderBottom: "2px solid #bfbfbf" }}
						/>
					</div>
					<div className="clearfix" />
				</div>
			</div>
		</>
	);
};

const ChartDisplay = ({ stats, currency }) => {
	const [section, setSection] = useState("people");

	const [itemsPerPage, setItemsPerPage] = useState(15);
	const [page, setPage] = useState(0);
	const start = page * itemsPerPage;
	const end = (page + 1) * itemsPerPage;
	const lastPage = Math.ceil(stats?.length / itemsPerPage);

	const Pagination = () => {
		if (stats?.length <= 0) return null;
		return (
			<thead>
				<tr>
					<th colSpan={7}>
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go To Page 1"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(0);
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 5 Pages"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(Math.max(page - 5, 0));
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 1 Page"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(page - 1);
									}}
									disabled={page === 0}
								>
									<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<strong>
									Page {page + 1}/{lastPage}
								</strong>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title={`Go to Page ${lastPage}`}
									onClick={() => {
										if (page !== lastPage - 1) setPage(lastPage - 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title="Go Forward 5 Pages"
									onClick={() => {
										if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									title="Go Forward 1 Page"
									onClick={() => {
										if (page !== lastPage - 1) setPage(page + 1);
									}}
									style={{ marginRight: "0.5rem" }}
									disabled={page === lastPage - 1}
								>
									<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		);
	};
	return (
		<>
			<div className="col-xs-12 p-0 pl-3 mt-5">
				<div
					className={`btn ${section == "people" ? "btn-primary" : ""}`}
					style={{
						borderRadius: "1rem 0rem 0rem 1rem",
						width: "20%",
						backgroundColor: section == "people" ? "" : "#f2f2f2",
						color: section == "people" ? "" : "rgb(234,97,28)",
					}}
					onClick={() => setSection("people")}
				>
					Employees
				</div>
				<div
					className={`btn ${section == "payrolls" ? "btn-primary" : ""}`}
					style={{
						borderRadius: "0rem 0rem 0rem 0rem",
						width: "20%",
						backgroundColor: section == "payrolls" ? "" : "#f2f2f2",
						color: section == "payrolls" ? "" : "rgb(234,97,28)",
					}}
					onClick={() => setSection("payrolls")}
				>
					Payrolls
				</div>
				<div
					className={`btn ${section == "businesses" ? "btn-primary" : ""}`}
					style={{
						borderRadius: "0rem 1rem 1rem 0rem",
						width: "20%",
						backgroundColor: section == "businesses" ? "" : "#f2f2f2",
						color: section == "businesses" ? "" : "rgb(234,97,28)",
					}}
					onClick={() => setSection("businesses")}
				>
					Businesses
				</div>
			</div>
			<div
				className="col-xs-12"
				style={{ overflowX: "auto", maxWidth: "100%" }}
			>
				<table className="table-responsive table table-hover">
					<Pagination />
					<thead>
						<tr style={{ display: section == "people" ? "" : "none" }}>
							<th style={{ textAlign: "center" }}>Period</th>
							<th style={{ textAlign: "center" }}>Part-Time</th>
							<th style={{ textAlign: "center" }}>Full-Time</th>
							<th style={{ textAlign: "center" }}>Director</th>
							<th style={{ textAlign: "center" }}>Joiners</th>
							<th style={{ textAlign: "center" }}>Leavers</th>
							<th style={{ textAlign: "center" }}>Casual</th>
							<th style={{ textAlign: "center" }}>Contractors</th>
							<th style={{ textAlign: "center" }}>Casual Contractors</th>
							<th style={{ textAlign: "center" }}>Cis Contractors</th>
							<th style={{ textAlign: "center" }}>Off Payroll Workers</th>
							<th style={{ textAlign: "center" }}>Total Employees</th>
						</tr>
						<tr style={{ display: section == "payrolls" ? "" : "none" }}>
							<th style={{ textAlign: "center" }}>Period</th>
							<th style={{ textAlign: "center" }}>Gross</th>
							<th style={{ textAlign: "center" }}>Net</th>
							<th style={{ textAlign: "center" }}>Tax</th>
							<th style={{ textAlign: "center" }}>Total Cost</th>
							<th style={{ textAlign: "center" }}>Total Payrolls</th>
						</tr>
						<tr style={{ display: section == "businesses" ? "" : "none" }}>
							<th>Period</th>
							<th style={{ textAlign: "center" }}>Independent</th>
							<th style={{ textAlign: "center" }}>Paid By Advisor</th>
							<th style={{ textAlign: "center" }}>Total Businesses</th>
						</tr>
					</thead>
					<tbody>
						{stats?.map((stat) => {
							return (
								<>
									<tr style={{ display: section == "people" ? "" : "none" }}>
										<td>{stat?.period}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.partTime}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.fullTime}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.director}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.joiners}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.leavers}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.casual}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.contractors}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.casualContractors}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.cisContractor}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.offPayrollWorker}</td>
										<td style={{ textAlign: "center" }}>{stat?.people?.count}</td>
									</tr>
									<tr style={{ display: section == "payrolls" ? "" : "none" }}>
										<td>{stat?.period}</td>
										<td style={{ textAlign: "center" }}>
											{currency}
											{parseFloat(stat?.payroll?.gross).toFixed(2)}
										</td>
										<td style={{ textAlign: "center" }}>
											{currency}
											{parseFloat(stat?.payroll?.net).toFixed(2)}
										</td>
										<td style={{ textAlign: "center" }}>
											{currency}
											{parseFloat(stat?.payroll?.tax).toFixed(2)}
										</td>
										<td style={{ textAlign: "center" }}>
											{currency}
											{parseFloat(stat?.payroll?.totalCost).toFixed(2)}
										</td>
										<td style={{ textAlign: "center" }}>{stat?.payroll?.count}</td>
									</tr>
									<tr style={{ display: section == "businesses" ? "" : "none" }}>
										<td>{stat?.period}</td>
										<td style={{ textAlign: "center" }}>
											{stat?.businesses?.count - stat?.businesses?.paidByAdvisor}
										</td>
										<td style={{ textAlign: "center" }}>{stat?.businesses?.paidByAdvisor}</td>
										<td style={{ textAlign: "center" }}>{stat?.businesses?.count}</td>
									</tr>
								</>
							);
						})}
					</tbody>
				</table>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const jurisdiction = state.advisors?.settings?.jurisdiction;
	const jurisdictionList = state.jurisdictions;

	const currency = jurisdictionList?.find((j) => j.countryCode === jurisdiction)?.currency;

	return {
		currency,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StatsModal);
